"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetsNames = void 0;
exports.assetsNames = {
    loginModal: {
        headerImage: 'store_icon.png',
        headerImageAlt: 'Retângulo vertical com desenho de toldo verde, ícone de pessoa no centro e duas sacolas verdes na parte inferior',
    },
};
